import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

import { Tooltip } from 'react-tooltip';
import useRouter from '../hook/useRouter';
import { ICollectionItemList } from '../interface/ICollection';
import { ISearchParam } from '../interface/ICommon';
import { CollectionItem } from './CollectionItem';

export const CollectionList = ({
    listData,
    collectionListParam,
    loading,
}: {
    listData: ICollectionItemList['contents'] | undefined;
    collectionListParam: ISearchParam;
    loading: boolean;
}) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const [favor, favorSet] = useState('');

    const { params, getValue, changeParam } = useRouter(['favorite']);
    useEffect(() => {
        if (!params) return;
        favorSet(getValue('favorite'));
    }, [params]);

    if (!listData) {
        return null;
    }

    return (
        <section className="gameinfo-result__list">
            {loading && (
                <div className="gameinfo-loader is-show">
                    <span className="loader"></span>
                </div>
            )}

            {listData.length < 1 && (
                <div
                    className="nodata"
                    style={{ display: 'block' }}
                    dangerouslySetInnerHTML={{
                        __html: favor === 'true' ? l10n['common.noresultsfavs'].toString() : l10n['common.noresultsitemprice'].toString(),
                    }}
                ></div>
            )}

            <div className="ui-table" data-tabletype="collection" style={{ display: listData.length < 1 ? 'none' : 'table' }}>
                <div className="tablehead">
                    <div className="tablerow">
                        <div className="tablecell favorite"></div>
                        <div className="tablecell">컬렉션</div>
                        <div className="tablecell">
                            현 최저가
                            <button className="ico-q" data-tooltip-id="my-tooltip"></button>
                            <Tooltip
                                id="my-tooltip"
                                html={`최저가 보기 버튼을 클릭하면 각 아이템의 현재 최저가와 합산 가격을 확인할 수 있습니다.`}
                            />
                        </div>
                        <div className="tablecell">수집 아이템</div>
                    </div>
                </div>
                <div className="tablebody">
                    {listData.map((it, idx) => (
                        <CollectionItem key={it.collectionId + it.collectionName} it={it} />
                    ))}
                </div>
            </div>
        </section>
    );
};
